import * as React from 'react';
import { Button } from '@alifd/next';
import { StyleData } from '../../utils/types';
import { parseToCssCode, parseToStyleData } from '../../utils';
import MonacoEditor from '@rchh/lowcode-plugin-base-monaco-editor';
import Icon from '../../components/icon';
import { intlLocal } from './locale';

interface CodeProps {
  styleData: StyleData | any;
  onStyleDataChange: (val: any) => void;
}

const cssConfig = intlLocal();

const defaultEditorOption = {
  readOnly: false,
  // automaticLayout: true,
  folding: true, // Enable code folding by default
  wordWrap: 'off',
  formatOnPaste: true,
  fontSize: 12,
  tabSize: 2,
  scrollBeyondLastLine: false,
  fixedOverflowWidgets: false,
  snippetSuggestions: 'top',
  minimap: {
    enabled: false,
  },
  options: {
    lineNumbers: 'off',
    fixedOverflowWidgets: true,
    automaticLayout: true,
    glyphMargin: false,
    folding: false,
    lineDecorationsWidth: 0,
    lineNumbersMinChars: 0,
    hover: {
      enabled: false,
    },
  },
  scrollbar: {
    horizontal: 'auto',
  },
};

export default class CssCode extends React.Component<CodeProps> {
  state = {
    defaultEditorProps: {},
    cssCode: '',
    isCanSave: true,
    height: '100px',
  };

  componentWillReceiveProps(nextProps: CodeProps) {
    const cssCode = parseToCssCode(nextProps.styleData);
    this.setState({
      cssCode,
    });
  }

  componentDidMount() {
    const { styleData } = this.props;

    if (document.body.clientWidth >= 1860) {
      this.setState({
        offsetX: -400,
      });
    }

    const cssCode = parseToCssCode(styleData);
    // console.log('cssCode', cssCode);

    this.setState({
      cssCode,
    });
  }

  styleSave = () => {
    const { cssCode } = this.state;
    const { onStyleDataChange } = this.props;
    const newStyleData = parseToStyleData(cssCode);
    // Check whether it's exactly the same as the original styleData
    if (newStyleData) {
      onStyleDataChange(newStyleData);
      this.setState({
        isCanSave: true,
      });
    }
  };

  updateCode = (newCode: string) => {
    this.setState({
      cssCode: newCode,
    });
    const newStyleData = parseToStyleData(newCode);
    if (newStyleData) {
      this.setState({
        isCanSave: false,
      });
    }
  };
  // Cached height
  prevHeight = 80;
  render() {
    const { cssCode, defaultEditorProps, isCanSave, height } = this.state;
    const handleEditorMount = (monaco: any, editor: any) => {
      editor.onDidBlurEditorWidget(() => {
        this.styleSave();
      });
      editor.onDidChangeModelDecorations(() => {
        updateEditorHeight();
        // Throttle the refresh rate
        requestAnimationFrame(updateEditorHeight);
      });
      const updateEditorHeight = () => {
        const padding = 20;
        const lineHeight = editor.getOption(monaco.editor.EditorOption.lineHeight);
        const lineCount = editor.getModel()?.getLineCount() || 1;
        const height = lineCount * lineHeight + padding;
        if (this.prevHeight !== height) {
          this.prevHeight = height;
          this.setState({height: `${height}px`})
          editor.layout();
        }
      };
      // Adapt the height on mount first
      updateEditorHeight()
    };

    return (
      <div>
        <div
          style={{
            marginBottom: '5px',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'space-between',
          }}
        >
          <Icon type="icon-CSS" />
          <Button type="primary" onClick={this.styleSave} disabled={isCanSave} size="small">
            {cssConfig.save}
          </Button>
        </div>
        {this.state.cssCode && (
          <MonacoEditor
            value={cssCode}
            {...defaultEditorProps}
            {...defaultEditorOption}
            {...{ language: 'css' }}
            onChange={(newCode: string) => this.updateCode(newCode)}
            editorDidMount={handleEditorMount}
            height={height}
          />
        )}
      </div>
    );
  }
}
